import { useId, useMemo } from "react";
import { Feature, Polygon, MultiPolygon } from "geojson";
import { Color } from "@deck.gl/core";
import { PathStyleExtension } from "@deck.gl/extensions";
import { GeoJsonLayer, GeoJsonLayerProps } from "@deck.gl/layers";

const WHITE: Color = [255, 255, 255, 255];

export function useRadiusBufferLayer({
  feature,
  color = WHITE,
}: {
  feature?: Feature<Polygon | MultiPolygon> | null;
  color?: Color;
}) {
  const id = useId();

  return useMemo(() => {
    return new GeoJsonLayer<Feature<Polygon | MultiPolygon>>({
      id: `${id}-radius-buffer`,
      data: feature,
      filled: false,
      getLineColor: color,
      stroked: true,
      getLineWidth: 3,
      lineWidthUnits: "pixels",
      extensions: [new PathStyleExtension({ dash: true, highPrecisionDash: true })],
      getDashArray: [3, 3],
    } as GeoJsonLayerProps<Feature<Polygon | MultiPolygon>>);
  }, [feature, color, id]);
}
